import { importProvidersFrom, inject, NgModule } from '@angular/core';
import { APP_BASE_HREF, LocationStrategy, PlatformLocation } from '@angular/common';

import { MatIconRegistry } from '@angular/material/icon';

import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgEventOptionsModule } from 'ng-event-options';

import { PublicModule } from '@player/shared/modules/public.module';

import { StorageLocation } from '@shared/strategies/storage-location.strategy';
import { ZefRouting } from './zef.routing';
import { ZefApp } from './zef.component';
import { IS_PUBLISHED } from '@shared/tokens/is-published.token';
import { ZefSentryModule } from '@shared/modules/sentry/zef-sentry.module';
import { StorageModule } from '@shared/modules/storage.module';

@NgModule({
  bootstrap: [ZefApp],
  declarations: [ZefApp],
  exports: [],
  imports: [ZefRouting, PublicModule, BrowserModule, BrowserAnimationsModule, NgEventOptionsModule],
  providers: [
    importProvidersFrom(ZefSentryModule),
    importProvidersFrom(StorageModule),
    {
      provide: IS_PUBLISHED,
      useValue: true,
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: LocationStrategy,
      useClass: StorageLocation,
      deps: [APP_BASE_HREF, PlatformLocation],
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class ZefModule {
  constructor() {
    const registry = inject(MatIconRegistry);

    registry.registerFontClassAlias('zefplayer', 'zef-icons-free');
    registry.setDefaultFontSetClass('zef-icons-free');
  }
}
